import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import CleanList from './components/CleanList';

const { Cell } = ResponsiveGrid;

const Clean = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="清潔列表"
        // description="清潔列表"
        breadcrumbs={[
          {
            name: '清潔工作',
          },
          {
            name: '清潔列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <CleanList />
    </Cell>
  </ResponsiveGrid>
);

export default Clean;
